import React from "react";
import { Link } from "react-router-dom";

import { getCsWhatsAppUrl } from "../../lib/contact";
import { storefrontUrl } from "../../lib/storefront";

/**
 * Chips under the hero search: things to do, not articles to read (spec 4.1).
 * The first is the primary chip. Entries come from data/home.js.
 */
const QuickActions = ({ actions }) => (
  <div className="hc-chips">
    <span className="hc-chips__label">Paling sering dicari:</span>
    {actions.map((action, index) => {
      const className = `hc-chip${index === 0 ? " hc-chip--primary" : ""}`;

      if (action.article) {
        return (
          <Link key={action.label} to={`/${action.article.category}/${action.article.slug}`} className={className}>
            {action.label}
          </Link>
        );
      }

      const href = action.whatsapp ? getCsWhatsAppUrl(action.whatsapp) : storefrontUrl(action.href);
      return (
        <a
          key={action.label}
          href={href}
          className={className}
          target={action.whatsapp ? "_blank" : undefined}
          rel={action.whatsapp ? "noopener noreferrer" : undefined}
        >
          {action.label}
        </a>
      );
    })}
  </div>
);

export default QuickActions;
